export default __webpack_public_path__ + "static/media/appLogo.4e95a879.png";